<template >
  <DialogCenter />
  <div class="main-container">

    <RouterView />
    <div class="app-version">{{ 'V'+version }}</div>
  </div>
</template>

<script setup lang="ts">
import { inject, onMounted,ref, provide } from 'vue';
import { RouterLink, RouterView } from 'vue-router'
import {
  load,
  loadMessages,
} from '@progress/kendo-vue-intl';
import fr from '@/locales/fr.json';
import en from '@/locales/en.json';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';

import numbers from 'cldr-numbers-full/main/en-CA/numbers.json';
import currencies from 'cldr-numbers-full/main/en-CA/currencies.json';
import caGregorian from 'cldr-dates-full/main/en-CA/ca-gregorian.json';
import dateFields from 'cldr-dates-full/main/en-CA/dateFields.json';
import timeZoneNames from 'cldr-dates-full/main/en-CA/timeZoneNames.json';

import frnumbers from 'cldr-numbers-full/main/fr-CA/numbers.json';
import frcurrencies from 'cldr-numbers-full/main/fr-CA/currencies.json';
import frcaGregorian from 'cldr-dates-full/main/fr-CA/ca-gregorian.json';
import frdateFields from 'cldr-dates-full/main/fr-CA/dateFields.json';
import frtimeZoneNames from 'cldr-dates-full/main/fr-CA/timeZoneNames.json';

import DialogCenter from "@/components/DialogCenter/DialogCenter.vue";
import $ from 'jquery';
import { VPdfViewer, useLicense } from "@vue-pdf-viewer/viewer";

const kendoForm = inject('kendoForm', {});
const version = ref(appVersion);

//remplace la fleche vers le bas des liste d�roulante par un chevron
//const faChevronDown = {
//    name: 'chevron-down',
//    content: '<path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>',
//    viewBox: '0 0 512 512',
//};

//provide('kendoIcons', {
//    type: 'svg',
//    icons: {
//        'caret-alt-down': faChevronDown,
//    },
//});
//fin de remplacement

declare var currentLang: any;
var appLanguage = '';

try {
  appLanguage = currentLang;
} catch (error) {

}


onMounted(() => {
  var lang = new URL(location.href).searchParams.get('lg');
  if (lang == 'fr') {
    i18n.locale.value = 'fr-CA';
  }
  if (lang == 'en') {
    i18n.locale.value = 'en-CA';
  }
  if (lang == undefined && appLanguage == '') {
    i18n.locale.value = 'fr-CA';

  }
  //On cache les scroll lorsqu'on est pas en DEV et pas dans un iframe
  if (!import.meta.env.DEV) {
    if (window.self !== window.top) {
      $('html').addClass('hide-scroll')
    }
  } else {
    $('html').removeClass('hide-scroll')
  }
});

load(
  likelySubtags,
  currencyData,
  weekData,
  frnumbers,
  frcurrencies,
  frcaGregorian,
  frdateFields,
  frtimeZoneNames,
  numbers,
  currencies,
  caGregorian,
  dateFields,
  timeZoneNames
);

const i18n: any = inject('i18n');
const YOUR_DOMAIN_TOKEN =
    import.meta.env.VITE_VPV_LICENSE
useLicense(YOUR_DOMAIN_TOKEN);


loadMessages(fr.kendo, i18n.locale.value);
loadMessages(fr, 'fr-CA');
loadMessages(en, 'en-CA');

</script>

<style scoped>
.app-version{
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 5px;
  font-size: 8px;
  color: #888;
  background-color: transparent;
  border-top-left-radius: 5px;
}
</style>
